module.exports = __webpack_public_path__ + "static/media/surper-5.0127f9f5.jpg";